import axios from 'axios'
import { z } from 'zod'
import { runAsyncWithRetries } from 'utils/promises'
import { PetDetectionResultSchema } from './PhotoBank.schemas'
import { tracingHeaders } from './faces'

export async function detectPetsFromFiles(files: Blob[]) {
  const formData = new FormData()
  files.forEach((file) => formData.append('files', file))
  const response = await runAsyncWithRetries({
    op: () =>
      axios.post('/photo-api-v2/v3/pets', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...tracingHeaders(),
        },
      }),
    opName: 'detectPetsFromFiles',
    numRetries: 3,
  })

  return parsePetDetectionResults(response.data, files.length)
}

export async function detectPetsFromUrl(urls: string[]) {
  const response = await runAsyncWithRetries({
    op: () =>
      axios.post(
        '/photo-api-v2/v3/pets-url',
        { urls },
        { headers: tracingHeaders() }
      ),
    opName: 'detectPetsFromUrl',
    numRetries: 3,
  })

  return parsePetDetectionResults(response.data, urls.length)
}

function parsePetDetectionResults(responseData: unknown, photoCount: number) {
  return z
    .array(PetDetectionResultSchema)
    .length(photoCount)
    .parse(responseData)
}
